



































import { Vue, Prop, Component, Watch } from 'vue-property-decorator';
import * as api from '@/store/api';
import router from '@/router';
import { LetterOwnerWithPicture } from '@/store/models/LetterOwner/letterOwnerWithPicture';
import { getOwnerRecipients } from '@/store/Services/letterOwnerService';
import * as $ from 'jquery';
import store from '@/store';


@Component
export default class SingleCartableOwner extends Vue{
    ownerName= '';
    post = '';
    ownerImage = '';
    ownerCompanyName = '';
    letterOwners = [] as LetterOwnerWithPicture[];
    isOwnersLoaded = false;

    @Watch("letterOwners")
    onLetterOwnersChanged(n: LetterOwnerWithPicture[], o: LetterOwnerWithPicture[]){
        //$(".dropdown").dropdown({action: 'hide',silent: true});
        this.isOwnersLoaded = true;
    }
    async created(){
        const allLetterOwners  = await  api.getLetterOwners();
        this.letterOwners = allLetterOwners.filter(x=>!x.onlyForReceivingIncommingLetter);
        const currentLetterOwner = this.letterOwners[0];
        //this.selectedOwner = currentLetterOwner.id;
        this.post = currentLetterOwner.post;
        this.ownerName = currentLetterOwner.nameOnly;
        this.ownerCompanyName = currentLetterOwner.letterOwnerCompanyNameOnly;
        this.ownerImage = 'data:image/png;base64, ' + currentLetterOwner.picture;
        this.$store.commit("setOwnerId",currentLetterOwner.id);
        this.$store.commit("setCanSeeAllLetters",currentLetterOwner.canSeeSecuredLetters);
        this.$emit('on-letter-owner-set',false);
        this.$router.replace("ReceivedLetters");
        // $(".dropdown").dropdown({action: 'hide',silent: true});
        
    }
    //selectedOwner = '';
    onLetterOwnerChanged(ownerId: string)
    {
        const currentOwner = this.letterOwners.find(x=>x.id === ownerId /*this.selectedOwner*/);
        if(!currentOwner)return;
        this.post = currentOwner.post;
        this.ownerName = currentOwner.nameOnly;
        this.ownerImage = 'data:image/png;base64, ' + currentOwner.picture;
        this.$store.commit("setOwnerId",currentOwner.id);
        this.$store.commit("setCanSeeAllLetters",currentOwner.canSeeSecuredLetters);
        store.state.eventHub.$emit('update-enterpriseForms',ownerId)
        this.$emit('on-letter-owner-set',true);
        //this.$router.push("ReceivedLetters");
    }

     redirectToMain(){
        this.$router.push({ name: 'Login' })
    }

    redirectToChangePassword(){
        store.state.eventHub.$emit('change-password')
        // this.$router.push({ name: 'ChangePassword' })
    }

    mounted(){
        $("#cartableDrowpdown").dropdown({action: 'hide',silent: true});
        $("#cartables-dropdown").dropdown();
    }
    updated(){
        $("#cartables-dropdown").dropdown();
    }
    //isFirstClick = false;
    //activeDropdown(){
        //if(this.isFirstClick)return;
        //$(".dropdown").dropdown({action: 'hide',silent: true});
        //this.isFirstClick = true;
    //}
}
